/*
 * VULCAN
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/roadmapsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Roadmaps. */
var Roadmaps = /** @class */ (function () {
    /**
     * Create a Roadmaps.
     * @param {PortalContext} client Reference to the service client.
     */
    function Roadmaps(client) {
        this.client = client;
    }
    Roadmaps.prototype.getRoadmap = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getRoadmapOperationSpec, callback);
    };
    Roadmaps.prototype.getRoadmapByArea = function (area, options, callback) {
        return this.client.sendOperationRequest({
            area: area,
            options: options
        }, getRoadmapByAreaOperationSpec, callback);
    };
    return Roadmaps;
}());
export { Roadmaps };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getRoadmapOperationSpec = {
    httpMethod: "GET",
    path: "latest/api/v1/roadmaps",
    responses: {
        200: {
            bodyMapper: Mappers.RoadmapListResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getRoadmapByAreaOperationSpec = {
    httpMethod: "GET",
    path: "latest/api/v1/roadmaps/{area}",
    urlParameters: [
        Parameters.area
    ],
    responses: {
        200: {
            bodyMapper: Mappers.RoadmapResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=roadmaps.js.map